import { DESCRIPTION, HEADING } from '../../constants/update';

export default {
    breadcrumbs: {
        crumbs: [],
    },
    firstHeading: {
        heading: HEADING,
        description: DESCRIPTION,
    },
};
